import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/database';
import 'firebase/compat/storage';

const firebaseConfig = {
    apiKey: "AIzaSyBtO_WEsBmAZ2wsIjwvJboZR6XR2EuA-8c",
    authDomain: "codenexus-34bcc.firebaseapp.com",
    projectId: "codenexus-34bcc",
    storageBucket: "codenexus-34bcc.appspot.com",
    messagingSenderId: "544141820940",
    appId: "1:544141820940:web:b1f78e48eac8040c995a29",
    measurementId: "G-3PZ2EFKNYY"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

// Get the Firebase Auth instance
const auth = firebase.auth();

// Get the Firebase Realtime Database instance
const database = firebase.database();

// Get the Firebase Storage instance
const storage = firebase.storage();

export { auth, database, storage};
